import React, { Fragment } from "react";
import Sticky from "react-stickynode";
import { ThemeProvider } from "styled-components";
import { interiorTheme } from "common/theme/interior";
import { DrawerProvider } from "common/contexts/DrawerContext";
import Navbar from "containers/Interior/Navbar";
import Footer from "containers/Interior/Footer";
import Heading from "common/components/Heading";
import { ResetCSS } from "common/assets/css/style";
import {
  GlobalStyle,
  InteriorWrapper,
  ContentWrapper,
  BodyWrapper,
} from "containers/Interior/interior.style";
import SEO from "components/seo";

export default () => {
  return (
    <ThemeProvider theme={interiorTheme}>
      <Fragment>
        <SEO title="Shipping policy" />
        <ResetCSS />
        <GlobalStyle />

        {/* Start writing your markup from here. */}
        <InteriorWrapper>
          <Sticky top={0} innerZ={9999} activeClass="sticky-nav-active">
            <DrawerProvider>
              <Navbar />
            </DrawerProvider>
          </Sticky>
          <ContentWrapper>
            <BodyWrapper>
              <Heading as="h1" content="Shipping policy" />

              <p>
                <strong>Last Revised Date: March 20, 2020&nbsp;&nbsp;</strong>
                &nbsp;
              </p>

              <h3>Delivery date;&nbsp;</h3>

              <p>
                Any date or period for delivery shall be considered as
                indicative only, although it is our policy to try to fulfil all
                orders within 14 working days for stocked goods. Orders received
                over the weekend will be treated as having been placed at the
                commencement of the following working day (defined as being
                Monday
                –&nbsp;Friday&nbsp;9:00&nbsp;to&nbsp;17:00,&nbsp;excluding
                Public and Bank Holidays). Orders for products that are not
                readily available for immediate sale, will not be accepted
                unless agreed to by the customer. In such a
                case,&nbsp;Direct4.me&nbsp;will&nbsp;propose&nbsp;a delivery
                schedule, which shall also be considered as indicative
                only.&nbsp;Direct4.me&nbsp;accepts no liability or
                responsibility for delays in the delivery caused by the
                manufacturer, shipping company or any other third party. &nbsp;
              </p>

              <h3>Shipping for&nbsp;EU&nbsp;destinations&nbsp;&nbsp;</h3>

              <p>
                All products shipped to EU destinations are shipped from our EU
                based facility by our selected parcel delivery service and aims
                to deliver to mainland Europe within&nbsp;seven&nbsp;working
                days, rolling out to as much as ten&nbsp;working&nbsp;days for
                hard to get to&nbsp;destinations. All goods are shipped in
                accordance with the terms and conditions of the carrier selected
                by Direct4.me. &nbsp;
              </p>

              <h3>
                Shipping for&nbsp;all other destinations – non-&nbsp;EU
                (including UK) and worldwide&nbsp;
              </h3>

              <p>
                All products shipped to non-EU&nbsp;destination&nbsp;will be
                dispatched via an approved carrier.&nbsp;Delivery times will
                vary from country to country and will be estimated at the time
                of ordering.&nbsp;Prices for shipping are weight and volume
                dependent&nbsp;and will be calculated based on the country of
                destination.&nbsp;Non-&nbsp;EU&nbsp;deliveries may incur
                administration, handling, tax and customs import
                charges;&nbsp;the&nbsp;customers&nbsp;are responsible for paying
                these charges. Unless otherwise specifically stated or agreed,
                products are sold strictly&nbsp;with the payment with the
                order.&nbsp;Unfortunately,&nbsp;Direct4.me&nbsp;cannot provide
                information to the Customer of possible import duties, taxes,
                administration or handling charges as these vary widely from
                country to country. For information on current charges, the
                Customer should contact their local customs office and check
                what customs duties may be applied before proceeding with
                purchase from&nbsp;Direct4.me. The Customer should note that in
                the event that a shipment is intercepted by their local customs
                authorities and in the event that duties are applied or in the
                event that the carrier attempts delivery but cannot find the
                address due to insufficient or inaccurate address details or in
                the event that the carrier attempts delivery but there is no
                response, the courier has a policy that they will only hold the
                goods for approx. 4 days – after this time period they will
                either automatically and without warning return the goods to
                sender or may abandon or destroy the goods. Any costs associated
                with the return of the goods to&nbsp;Direct4.me, including any
                import duties, taxes, administration or handling charges must be
                paid by the Customer. &nbsp;The Customer will also be liable for
                any redelivery charges.&nbsp; &nbsp;
              </p>

              <h3>Non-delivered parcels&nbsp;</h3>

              <p>
                Our nominated courier service has a delivery policy of
                attempting delivery whereupon they will leave a card instructing
                the customer to either arrange a re-delivery or pick up the
                consignment from their nearest depot. If the customer does not
                collect the&nbsp;consignment or arrange a re-delivery, the
                consignment will be returned to&nbsp;Direct4.me&nbsp;Any charges
                incurred by&nbsp;us&nbsp;will be passed to the customer and
                required to be settled before the consignment is re-dispatched.
                The customer will also be liable for the cost of
                re-delivery&nbsp;
              </p>

              <p>&nbsp;</p>

              <h3>Free Shipping&nbsp;</h3>

              <p>
                Where an order is either designated as 'Free Shipping' or
                selected by the customer as 'Free
                Shipping',&nbsp;Direct4.me&nbsp;will choose an appropriate and
                available shipping method whereupon the relevant shipping policy
                and the carrier’s terms and conditions will apply as defined in
                these terms and conditions.&nbsp;
              </p>

              <p>&nbsp;</p>
            </BodyWrapper>
          </ContentWrapper>
          <Footer />
        </InteriorWrapper>
        {/* End of markup section. */}
      </Fragment>
    </ThemeProvider>
  );
};
